import { Box, Button, Grid } from "@mui/material";
import { useState, useEffect } from "react";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import toast from "react-hot-toast";
import CustomInput from "../components/ui/CustomInput";
import PageHeader from "../components/ui/PageHeader";
import PageForm from "../components/ui/PageForm";
import axios from "../api/maintenanceClient";
import { useLoading } from "../components/LoadingContext";
import { handleError, errorToast } from "../services/serviceBase";

const MAX_MESSAGE_LENGTH = 1000;

const MaintenanceSetup = () => {
  const intl = useIntl();
  const navigate = useNavigate();
  const { setLoading } = useLoading();

  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [messageEn, setMessageEn] = useState("");
  const [messageIt, setMessageIt] = useState("");

  useEffect(() => {
    setLoading(true);
    axios
      .get("/maintenance")
      .then((response) => {
        setLoading(false);
        const data = response.data;
        setFromDate(
          data.fromDate && dayjs(data.fromDate).isValid() && dayjs(data.fromDate).year() > 1
            ? dayjs(data.fromDate)
            : null
        );
        setToDate(
          data.toDate && dayjs(data.toDate).isValid() && dayjs(data.toDate).year() > 1
            ? dayjs(data.toDate)
            : null
        );
        setMessageEn(data.messageEn || "");
        setMessageIt(data.messageIt || "");
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, () => {
          errorToast(error, intl);
        });
      });
  }, []);

  const handleCancel = () => {
    navigate(-1);
  };

  const handleSave = () => {
    if (messageEn.length > MAX_MESSAGE_LENGTH || messageIt.length > MAX_MESSAGE_LENGTH) {
      toast.error(intl.formatMessage({ id: "MaintenanceSetup.MessageTooLong" }));
      return;
    }

    if (fromDate != null && toDate != null && fromDate > toDate) {
      toast.error(intl.formatMessage({ id: "Error.StartDateLaterThenEndDate" }));
      return;
    }

    setLoading(true);
    axios
      .post("/maintenance", {
        fromDate: fromDate ? fromDate.toISOString() : null,
        toDate: toDate ? toDate.toISOString() : null,
        messageEn,
        messageIt,
      })
      .then(() => {
        setLoading(false);
        toast.success(intl.formatMessage({ id: "General.Saved" }));
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, () => {
          errorToast(error, intl);
        });
      });
  };

  return (
    <Box sx={{ overflow: "hidden" }}>
      <PageHeader title={intl.formatMessage({ id: "MaintenanceSetup.Title" })} />
      <PageForm
        form={
          <form>
            <Grid container spacing={2}>
              <Grid item xs={12} md={5}>
                <CustomInput
                  labelText={intl.formatMessage({ id: "General.FromDate" })}
                  type="datetime"
                  valueRef={fromDate}
                  setValue={setFromDate}
                  wideTimeColumns
                  localTimezone
                  textCol={4}
                  inputCol={8}
                />
              </Grid>
              <Grid item md={2}></Grid>
              <Grid item xs={12} md={5}>
                <CustomInput
                  labelText={intl.formatMessage({ id: "General.ToDate" })}
                  type="datetime"
                  valueRef={toDate}
                  setValue={setToDate}
                  wideTimeColumns
                  localTimezone
                  textCol={4}
                  inputCol={8}
                />
              </Grid>
            </Grid>
          </form>
        }
      />
      <Box sx={{ p: 2 }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <CustomInput
              labelText={intl.formatMessage({ id: "MaintenanceSetup.TextLabel" })}
              type="multiline"
              value={messageEn}
              setValue={setMessageEn}
              maxLength={MAX_MESSAGE_LENGTH}
              rows={6}
              textCol={12}
              inputCol={12}
            />
          </Grid>
          <Grid item xs={12}>
            <CustomInput
              labelText={intl.formatMessage({ id: "MaintenanceSetup.TestoLabel" })}
              type="multiline"
              value={messageIt}
              setValue={setMessageIt}
              maxLength={MAX_MESSAGE_LENGTH}
              rows={6}
              textCol={12}
              inputCol={12}
            />
          </Grid>
        </Grid>
      </Box>
      <Grid container spacing={2} sx={{ p: 2 }}>
        <Grid item xs={6} md={2} display="flex" justifyContent="flex-start">
          <Button
            variant="contained"
            sx={{ width: "100%" }}
            className="apeLigthBlueBackground"
            onClick={handleCancel}
          >
            {intl.formatMessage({ id: "General.Cancel" })}
          </Button>
        </Grid>
        <Grid item xs={0} md={8}></Grid>
        <Grid item xs={6} md={2} display="flex" justifyContent="flex-end">
          <Button
            variant="contained"
            sx={{ width: "100%" }}
            className="apeLigthBlueBackground"
            onClick={handleSave}
          >
            {intl.formatMessage({ id: "General.Save" })}
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

export default MaintenanceSetup;
